import { db } from '@/features/offline/db'

/**
 * Favoriten und Verlauf.
 *
 * Favoriten sind der eigentliche Zweck der Startseite: Wer im Einsatz zur App greift,
 * weiß meist schon, welche Karte er braucht. Deshalb liegen sie unsortiert-stabil in
 * selbst gewählter Reihenfolge, nicht nach Zugriff sortiert — eine Karte soll immer an
 * derselben Stelle liegen, auch wenn man nicht hinsieht.
 */

/** Größe des Verlaufs auf der Startseite. */
export const HISTORY_LIMIT = 6

export async function isFavorite(id: string): Promise<boolean> {
  return (await db.favorites.get(id)) !== undefined
}

export async function toggleFavorite(id: string): Promise<boolean> {
  const existing = await db.favorites.get(id)
  if (existing) {
    await db.favorites.delete(id)
    return false
  }
  const last = await db.favorites.orderBy('position').last()
  await db.favorites.put({ id, position: (last?.position ?? 0) + 1, addedAt: Date.now() })
  return true
}

/** Schreibt die Reihenfolge neu — erwartet die vollständige Liste in Zielreihenfolge. */
export async function reorderFavorites(ids: readonly string[]): Promise<void> {
  await db.transaction('rw', db.favorites, async () => {
    for (const [index, id] of ids.entries()) {
      await db.favorites.update(id, { position: index })
    }
  })
}

export async function recordVisit(id: string): Promise<void> {
  await db.history.put({ id, openedAt: Date.now() })
  // Verlauf beschnitten halten; alles Ältere ist für die Startseite ohne Wert.
  const all = await db.history.orderBy('openedAt').reverse().toArray()
  for (const entry of all.slice(HISTORY_LIMIT * 3)) {
    await db.history.delete(entry.id)
  }
}
